/* tslint:disable */
/* eslint-disable */
/**
 * user
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRegistration
 */
export interface UserRegistration {
    /**
     * User's email
     * @type {string}
     * @memberof UserRegistration
     */
    email: string;
    /**
     * User's password
     * @type {string}
     * @memberof UserRegistration
     */
    password: string;
}

export function UserRegistrationFromJSON(json: any): UserRegistration {
    return UserRegistrationFromJSONTyped(json, false);
}

export function UserRegistrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRegistration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function UserRegistrationToJSON(value?: UserRegistration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

